import angular from 'angular';
import template from './template.html';
import { TFTTile } from '../../../../../common/tft-tile';
import './style.scss';
import { FILTER, PREFERRED, MANDATORY, OPTIONAL } from '../../../../../../constants/searchItemsPriority';

export const PRIORITY_VALUES = {
    FILTER: 1,
    MANDATORY: 0.99999,
    PREFERRED: 0.75,
    OPTIONAL: 0.5,
};
export const PRIORITY_CLASS_MAP = {
    [PRIORITY_VALUES.FILTER]: FILTER,
    [PRIORITY_VALUES.PREFERRED]: PREFERRED,
    [PRIORITY_VALUES.MANDATORY]: MANDATORY,
    [PRIORITY_VALUES.OPTIONAL]: OPTIONAL,
};

export class MatchedSkillTile extends TFTTile {
    constructor($scope, $element, $timeout, TFTTagsService) {
        super($scope);

        this.$element = $element[0];
        this.$timeout = $timeout;
        this.tftTagsService = TFTTagsService;
    }

    $onChanges() {
        const { skill } = this;
        const { className, styles } = this.tftTagsService.getTagStyles({ priority: this.getPriorityClass(skill), isDerived: skill.isDerived });

        this.className = className;
        this.styles = styles;
    }

    getPriorityClass(skill) {
        return PRIORITY_CLASS_MAP[skill.priorityValue] || '';
    }
}

export const MatchedSkillTileConfiguration = {
    template,
    controller: MatchedSkillTile,
    bindings: {
        skill: '<',
        hideCheckmark: '<',
    },
    controllerAs: 'matchedSkillTileCtrl',
};

angular.module('TALENYA-FE').component('matchedSkillTile', MatchedSkillTileConfiguration);
